export interface TranslationSubStatus {
  step: number;
  message: string;
}

export const TRANSLATION_SUB_STEPS: Record<number, TranslationSubStatus> = {
  1: { step: 1, message: 'Preparing data…' },
  2: { step: 2, message: 'Generating XLIFF files…' },
  3: { step: 3, message: 'Translating content…' },
  4: { step: 4, message: 'Processing results…' },
  5: { step: 5, message: 'Applying translations…' },
};
